module.exports = __webpack_public_path__ + "img/certificate03-2-2.0ec336d0.jpg";